import React from "react";
import { ContainerAuto } from "@/shared/ContainerAuto";
import { handleClick } from "@/shared/Analitics/GoogleAnalytics4";
import { SeparatorLinksRecipesContainer } from "./styles";

export const SubMenuArq = ({ title, items, isTitleHeader = false }) => {
  return (
    <SeparatorLinksRecipesContainer>
      <ContainerAuto className="containerAutoFlex">
        <div className={`links-recipes ${!isTitleHeader ? "is-not-title-header" : ""}`}>
          <div className="links-recipes-items">
            {title && <h1 className="title">{title}</h1>}
            {items?.length > 0 && (
              <>
              <div className="links-separator"></div>
              <div className="links-container">
                {items?.map((link, index) => {
                  return (
                    <React.Fragment key={index}>
                      <a
                        className="links-recipes-link"
                        href={link.slug}
                        onClick={() => {
                          handleClick(
                            "ui_interaction",
                            `header ${title}`,
                            link.name,
                          );
                        }}
                      >
                        {link.name}
                      </a>
                      <div className="links-recipes-dot"></div>
                    </React.Fragment>
                  );
                })}
              </div>
              </>
            )}
          </div>
        </div>
      </ContainerAuto>
    </SeparatorLinksRecipesContainer>
  );
};
